import React from 'react';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';
import { getLuminance } from '@material-ui/core/styles/colorManipulator';

const styles = (theme: Theme) => {
  const { color, colorFlashing } =
    getLuminance(theme.palette.secondary.contrastText) > 0.5
      ? { color: '#fff', colorFlashing: '#ddd' }
      : { color: '#aaa', colorFlashing: '#ccc' };

  return createStyles({
    // https://codepen.io/nzbin/pen/GGrXbp
    root: {
      position: 'relative',
      width: 10,
      height: 10,
      borderRadius: 5,
      backgroundColor: color,
      color,
      animation: 'dotFlashing .5s infinite linear alternate',
      animationDelay: '.3333s',
      '&::before, &::after': {
        content: '""',
        display: 'inline-block',
        position: 'absolute',
        top: 0,
      },
      '&::before': {
        left: -12,
        width: 10,
        height: 10,
        borderRadius: 5,
        backgroundColor: color,
        color,
        animation: 'dotFlashing .5s infinite alternate',
        animationDelay: '0s',
      },
      '&::after': {
        left: 12,
        width: 10,
        height: 10,
        borderRadius: 5,
        backgroundColor: color,
        color,
        animation: 'dotFlashing .5s infinite alternate',
        animationDelay: '.6666s',
      },
    },
    '@keyframes dotFlashing': {
      '0%': {
        backgroundColor: color,
      },
      '50%, 100%': {
        backgroundColor: colorFlashing,
      },
    },
  });
};

export interface IconDotsFlashingProps extends WithStyles<typeof styles>, React.HTMLAttributes<HTMLDivElement> {}

const IconDotsFlashing: React.FC<IconDotsFlashingProps> = ({ classes, ...rest }) => (
  <div className={classes.root} {...rest} />
);

export default withStyles(styles, { name: 'IconDotsFlashing' })(IconDotsFlashing);
